module.exports = __webpack_public_path__ + "img/top_ogp.224f938.png";